











































































import {Component, Vue} from 'vue-property-decorator';
import Axios from "axios";
import Session from "@/App/controller/account/session";
import Url from "@/App/controller/net/url";
import {TITLE_DEFAULT} from "@/App/data/define";
import AdmincpMenu from "@/App/component/admincp-menu.vue";
@Component({
    components: {AdmincpMenu}
})
export default class AdmincpGameCreatePage extends Vue {
    public readonly name: string = 'admincp-game-create'
    private HasDataSend: boolean = false
    private FormValues: {
        id_category: number,
        key: string,
        name: string,
        icon: string,
        background: string,
        updateurl: string,
        execute: string,
        buttonname: string,
        versionfile: string,
        versionhash: string,
        nowversion: string,
        htmlpage: string,
        needsteam: number,
        params: string
    } = {
        id_category: 0,
        key: '',
        name: '',
        icon: '',
        background: '',
        updateurl: '',
        execute: '',
        buttonname: '',
        versionfile: '',
        versionhash: '',
        nowversion: '',
        htmlpage: '',
        needsteam: 0,
        params: '[]',
    }
    private ListCategory: {
        id: number,
        name: string
    }[] = []

    private created(): void {
        document.title = "Создание игры - " + TITLE_DEFAULT
        Axios.post('//kosiaks.alkad.org/api/index.php', {
            method: 'category.list',
            //@ts-ignore
            session: Session.CurrentSession.SessionID,
        }).then(res => {
            if (res.data.code === 0) {
                Vue.set(this, 'ListCategory', res.data.result)
            }
        })
    }

    private OnSubmit(): void {
        this.HasDataSend = true
        Axios.post('//kosiaks.alkad.org/api/index.php', {
            method: 'game.create',
            //@ts-ignore
            session: Session.CurrentSession.SessionID,
            id_category: this.FormValues.id_category,
            key: this.FormValues.key,
            name: this.FormValues.name,
            icon: this.FormValues.icon,
            background: this.FormValues.background,
            updateurl: this.FormValues.updateurl,
            execute: this.FormValues.execute,
            buttonname: this.FormValues.buttonname,
            versionfile: this.FormValues.versionfile,
            versionhash: this.FormValues.versionhash,
            nowversion: this.FormValues.nowversion,
            htmlpage: this.FormValues.htmlpage,
            needsteam: this.FormValues.needsteam,
            params: this.FormValues.params,
        }).then(res => {

        }).finally(() => {
            this.HasDataSend = false
            Url.SetUrl('/admincp/game/')
        })
    }
}
